import type { ICurrencyDropDownItem, IDropDownItem } from 'BreetHelpers';
import { useModalApi } from 'BreetHooks';
import { type MouseEvent, type ReactNode, useCallback, useMemo, useState } from 'react';

import type { IFundRequestContext } from '../DialogFundRequest.helpers';
import { FundRequestContext } from './FormContext';

export const FundRequestProvider = ({ children }: { children?: ReactNode }) => {
	const { openModalDirect } = useModalApi();

	const [selectedWallet, setSelectedWallet] = useState<ICurrencyDropDownItem | undefined>();
	const [fundingMethod, setFundingMethod] = useState<string>('');

	const selectWallet = useCallback((wallet?: ICurrencyDropDownItem) => {
		setSelectedWallet(wallet);
		setFundingMethod('');
	}, []);

	const selectFundingMethod = useCallback(
		(item: IDropDownItem) => (e: MouseEvent<HTMLButtonElement>) => {
			e.preventDefault();

			if (item.value === 'Crypto') {
				openModalDirect({ id: 'cryptoSettings' });
			}

			setFundingMethod(item.value);
		},
		[openModalDirect]
	);

	const providerValue = useMemo(
		(): IFundRequestContext => ({
			selectedWallet,
			selectFundingMethod,
			selectWallet,
			fundingMethod,
		}),
		[selectedWallet, selectFundingMethod, selectWallet, fundingMethod]
	);

	return <FundRequestContext.Provider value={providerValue}>{children}</FundRequestContext.Provider>;
};
